import { ClientListIcon } from "../components/atoms/icons/sidebar/ClientListIcon";
import { FileUploadIcon } from "../components/atoms/icons/sidebar/FileUploadIcon";
import { GroupListIcon } from "../components/atoms/icons/sidebar/GroupListIcon";
import { UploadResultIcon } from "../components/atoms/icons/sidebar/UploadResultIcon";
import { UserListIcon } from "../components/atoms/icons/sidebar/UserListIcon";
import { SidebarMenu } from "../ducks/app";
import { PageRoutes } from "./routes";

export const FILE_UPLOAD_SIDEBAR_MENUS: SidebarMenu[] = [
  {
    title: "ファイルアップロード",
    icon: FileUploadIcon,
    subMenus: [
      {
        title: "人事ファイル（共通）",
        path: PageRoutes.FILE_UPLOAD.replace(":menuId", "1"),
      },
      {
        title: "予約ファイル（共通）",
        path: PageRoutes.FILE_UPLOAD.replace(":menuId", "2"),
      },
      {
        title: "人事ファイル（個別）",
        path: PageRoutes.FILE_UPLOAD.replace(":menuId", "3"),
      },
    ],
  },
  {
    title: "アップロード結果一覧",
    path: PageRoutes.FILE_UPLOAD_RESULT,
    icon: UploadResultIcon,
  },
];

export const ACCOUNT_MANAGEMENT_SIDEBAR_MENUS: SidebarMenu[] = [
  {
    title: "顧客一覧",
    path: PageRoutes.CLIENTS,
    icon: ClientListIcon,
  },
  {
    title: "グループ一覧",
    path: PageRoutes.GROUPS,
    icon: GroupListIcon,
  },
  {
    title: "アカウント一覧",
    path: PageRoutes.USERS,
    icon: UserListIcon,
  },
];
